import {
  MapRounded,
  Dashboard,
  DvrOutlined,
  ListAltOutlined,
  Backup,
  AccountCircleOutlined,
  ForumOutlined,
  AccountTreeOutlined,
} from '@mui/icons-material';
import {map} from '../routes/RouteMap';

export const CONSTANT = {
  FOOTER: {
    COPYRIGHT: '© تمامی حقوق مادی و معنوی این وب سایت برای شرکت فن آوا محفوظ می‌باشد',
  },
  SIDEBAR: {
    MENU_ITEMS: [
      {
        id: 100,
        name: 'داشبورد',
        path: map.routes.dashboard,
        icon: Dashboard,
        isShow: false,
        roles: [],
        isPublic: false,
      },
      {
        id: 200,
        name: 'نقشه',
        path: map.routes.map,
        icon: MapRounded,
        isShow: true,
        roles: [],
        isPublic: true,
      },
      {
        id: 300,
        name: 'مدیریت سفارشات',
        path: map.routes.managerOrders,
        icon: DvrOutlined,
        isShow: true,
        roles: [
          'role_admin',
          'ROLE_page_order_manager',
        ],
        isPublic: false,
      },
      {
        id: 350,
        name: 'لیست سفارشات',
        path: map.routes.orders,
        icon: ListAltOutlined,
        isShow: true,
        roles: [],
        isPublic: false,
      },
      {
        id: 400,
        name: 'اپلود فایل',
        path: map.routes.shapeFileUpload,
        icon: Backup,
        isShow: true,
        roles: ['role_admin'],
        isPublic: false,
      },
      {
        id: 400,
        name: 'تیکت ها',
        path: map.routes.tickets,
        icon: ForumOutlined,
        isShow: true,
        roles: [
          'role_admin',
          'ROLE_page_ticket_manager',
          'ROLE_page_camunda_ticket_manager',
        ],
        isPublic: false,
      },
      {
        id: 500,
        name: 'سازمان ها',
        path: map.routes.organizations,
        icon: AccountTreeOutlined,
        isShow: true,
        roles: [
          'role_admin',
          'ROLE_default-roles-fanava',
        ],
        isPublic: false,
      },
    ],
    MENU_FINAL: [
      {
        id: 9100,
        name: 'پروفایل',
        path: map.routes.profile,
        icon: AccountCircleOutlined,
        isShow: true,
        roles: [],
        isPublic: false,
      },
      /* {
        id: 9900,
        name: 'ورود',
        path: map.routes.login,
        icon: AccountCircleOutlined,
        isShow: !access_token,
        roles: [],
      }, */
    ],
  },
  LAYERS: {
    DARK_LAYER: 'DARK_LAYER',
    LIGHT_LAYER: 'LIGHT_LAYER',
    SATELLITE_LAYER: 'SATELLITE_LAYER',
  },
};
